import { useCallback } from 'react'
import * as React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface ConfirmDeleteChatModalProps {
  name: string
  type?: 'chat' | 'trip'
}

function ConfirmDeleteChatModal({ name, type = 'chat' }: ConfirmDeleteChatModalProps) {
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const handleClose = useCallback(() => {
    modalElement.resolve(false)
  }, [modalElement])

  const handleConfirm = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  return (
    <Modal
      title={intl.formatMessage(
        {
          id: 'FgM6X-GyTTEA_Ytv9oQ6',
          defaultMessage: 'Delete {type}?',
          description: 'Modal title asking user to confirm deleting a chat or trip',
        },
        { type },
      )}
      primaryActionText={intl.formatMessage({
        id: 'q78XY3lQTi64ToIDsZGw',
        defaultMessage: 'Delete',
        description: 'Primary action button to confirm deleting a chat or trip',
      })}
      secondaryActionText={intl.formatMessage({
        id: 'ObaUQtGOQbcRJP8kdVP_',
        defaultMessage: 'Cancel',
        description: 'Secondary action button to cancel deleting a chat or trip',
      })}
      onPrimaryActionClick={handleConfirm}
      onSecondaryActionClick={handleClose}
      onClose={handleClose}
      tabletHeight="auto"
    >
      <BodyText variant="medium">
        <FormattedMessage
          id="LKkWxrR1ioGWutMTpy2x"
          defaultMessage="Are you sure you want to delete this {type} (<bold>{name}</bold>)? This action is permanent and cannot be undone."
          description="Confirmation message when deleting a chat or trip with the item name highlighted"
          values={{
            type,
            name,
            bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
          }}
        />
      </BodyText>
    </Modal>
  )
}

export default ConfirmDeleteChatModal
